import type { Theme } from '@mui/material';

export const styles = {
  baseSnackbarContainer: (theme: Theme) => ({
    bgcolor: theme.colors.white,
    color: theme.colors.black,
    flexWrap: 'nowrap',

    '&.MuiPaper-root': {
      padding: '1rem 1.5rem',
    },

    '> *': {
      p: 0,
    },
  }),

  baseSnackbarText: {
    direction: 'column',
    justifyContent: 'center',
    px: 2.5,
    maxWidth: '22rem',
  },
};
